/** A circular success (✓) / error (✕) badge for auth flow end-states
 * (verify-email, password reset, forgot-password). */
export function AuthStatusIcon({ variant }: { variant: 'success' | 'error' }) {
  const ok = variant === 'success';
  return (
    <span
      className={`flex h-12 w-12 items-center justify-center rounded-full ${
        ok ? 'bg-success-dim text-success' : 'bg-danger-dim text-danger'
      }`}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {ok ? <path d="m5 12 5 5L20 7" /> : <path d="M6 6l12 12M18 6 6 18" />}
      </svg>
    </span>
  );
}
